<!-- Barra thin de sesion delegada -->
<div
  class="delegated-session-bar"
  *ngIf="isSupportUx"
  [class.delegated-session-bar--restricted]="isDelegatedOrgRestricted"
  (click)="toggleSupportPopover()">
  <i
    class="pi"
    [class.pi-shield]="!isDelegatedOrgRestricted"
    [class.pi-exclamation-triangle]="isDelegatedOrgRestricted"></i>
  <span class="org-status-text" *ngIf="isDelegatedOrgRestricted">Organización inhabilitada</span>
  <span class="session-state-badge" *ngIf="isDelegatedOrgRestricted">{{ delegatedStatusText }}</span>
  <span class="time-badge">{{ timeRemainingFormatted }}</span>

  <!-- Popover con detalles -->
  <div class="support-popover" *ngIf="showSupportPopover" (click)="$event.stopPropagation()">
    <div class="popover-header">
      <h4>Sesión de Soporte</h4>
      <button class="close-btn" (click)="closeSupportPopover()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <div class="popover-body">
      <div class="info-row">
        <span class="label">Accediendo a:</span>
        <span class="value">{{ delegationInfo?.targetOrgName || delegationInfo?.targetOrgId }}</span>
      </div>
      <div class="info-row">
        <span class="label">ID de sesión:</span>
        <span class="value session-id">{{ delegationInfo?.targetOrgId }}</span>
      </div>
      <div class="info-row">
        <span class="label">Tiempo restante:</span>
        <span class="value">{{ timeRemainingFormatted }}</span>
      </div>
      <div class="info-row" *ngIf="isDelegatedOrgRestricted">
        <span class="label">Estado:</span>
        <span class="value status-value status-value--restricted">{{ delegatedStatusText }}</span>
      </div>
    </div>
    <div class="popover-footer">
      <button class="btn-return" (click)="returnToAdminWeb()">
        <i class="pi pi-arrow-left"></i>
        Volver a web de administración
      </button>
    </div>
  </div>
</div>

<p-toolbar aria-label="Actions" [class.header-content-hidden]="contentPanelOpen()">
  <ng-template pTemplate="start">
    <p-button icon="pi pi-bars" (onClick)="toggleSidebar()" severity="secondary" [rounded]="true" [text]="true"></p-button>
    <span *ngIf="showBrandText" class="brand-name" (click)="redirectHome()" style="cursor: pointer">
      <span class="brand-meta">META</span><span class="brand-bridge">BRIDGE</span>
    </span>
    <img *ngIf="!showBrandText && effectiveLogoUrl" [src]="effectiveLogoUrl" [alt]="logoAlt" class="module-logo"
         [style.cursor]="showHomeButton ? 'pointer' : 'default'"
         (click)="showHomeButton && redirectHome()" />
    <ng-content select="[toolbarStart]"></ng-content>
  </ng-template>
  <ng-template pTemplate="end">
    <div class="flex items-center">
      <ng-content select="[toolbarEnd]"></ng-content>
      <app-user-actions [moduleMenuItems]="menuItems"></app-user-actions>
    </div>
  </ng-template>
</p-toolbar>
